import { SavingsAndInvestmentsIncome } from '../../classes/savingsAndInvestmentsIncome/savingsAndInvestmentsIncome';
import { SingleTierTax } from '../../classes/singleTierTax/singleTierTax';
import { rates } from './config';
import { rates as inkomstenUitSparenEnBeleggen } from '../../classes/savingsAndInvestmentsIncome/config';
import { VermogensBelastingConfig } from './interface';

export class VermogensBelasting {

    belastingJaar: number;
    belastbaarRendement: number;
    rendementsGrondslag: number;
    aftrekbareSchulden: number;
    grondslagSparenEnBeleggen: number;
    aandeelRendementsGrondslag: number;
    voordeelSparenEnBeleggen: number;
    heffingsVrijVermogen: number;
    rendementBankTegoed: number;
    rendementBeleggingen: number;
    rendementSchulden: number;
    schuldenDrempel: number;
    tariefBox3: number;
    tax: number;

    constructor(data: VermogensBelastingConfig) {
        const config = inkomstenUitSparenEnBeleggen[data.year];
        const output = new SavingsAndInvestmentsIncome(config, data.input).calculate();

        this.belastingJaar = data.year;
        this.belastbaarRendement = output.belastbaarRendement;
        this.rendementsGrondslag = output.rendementsGrondslag;
        this.aftrekbareSchulden = output.aftrekbareSchulden;
        this.grondslagSparenEnBeleggen = output.grondslagSparenEnBeleggen;
        this.aandeelRendementsGrondslag = output.aandeelRendementsGrondslag;
        this.voordeelSparenEnBeleggen = output.voordeelSparenEnBeleggen;
        this.heffingsVrijVermogen = output.heffingsVrijVermogen;
        this.rendementBankTegoed = config.rendementBankTegoed;
        this.rendementBeleggingen = config.rendementBeleggingen;
        this.rendementSchulden = config.rendementSchulden;
        this.schuldenDrempel = config.schuldenDrempel;
        this.tariefBox3 = config.tariefBox3;
        this.tax = new SingleTierTax(rates[data.year], this.voordeelSparenEnBeleggen).tax;
    }

}
